import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "container", "hidden"]
  
  connect() {
    this.tags = []

    // Load existing tags from hidden jsonb field
    if (this.hiddenTarget.value) {
      try {
        this.tags = JSON.parse(this.hiddenTarget.value)
        this.renderTags()
      } catch (e) {
        console.error("Error parsing tags from hidden field", e)
        this.tags = []
      }
    }

    // Attach form-submit listener so we capture any residual input
    this.form = this.element.closest("form")
    if (this.form) {
      this._submitHandler = this.prepareSubmission.bind(this)
      this.form.addEventListener("submit", this._submitHandler)
    }
  }
  
  // Fired via keydown on the text input.  We treat both “Enter” and “,” as
  // delimiters so the user can type: `go-to-market, ai, growth` and press
  // enter or simply keep typing.
  handleInput(event) {
    if (event.key === 'Enter' || event.key === ',') {
      event.preventDefault()
      this.commitInput()
    }
  }
  
  addTag(tag) {
    // Convert to lowercase for case-insensitive comparison
    const normalizedTag = tag.toLowerCase()
    
    // Check if tag already exists (case-insensitive)
    if (!this.tags.some(t => t.toLowerCase() === normalizedTag)) {
      this.tags.push(tag)
      this.renderTags()
      this.updateHiddenField()
      this.inputTarget.value = ''
    }
  }
  
  removeTag(event) {
    const index = event.currentTarget.dataset.index
    if (index !== undefined) {
      this.tags.splice(index, 1)
      this.renderTags()
      this.updateHiddenField()
    }
  }
  
  renderTags() {
    this.containerTarget.innerHTML = this.tags.map((tag, index) => `
      <span class="tag inline-flex items-center gap-1 px-3 py-1 bg-gray-100 text-gray-700 rounded-full text-sm">
        ${tag}
        <button type="button" data-action="click->tags#removeTag" data-index="${index}" class="tag-remove ml-1">
          <i class="fas fa-times"></i>
        </button>
      </span>
    `).join('')
  }
  
  updateHiddenField() {
    this.hiddenTarget.value = JSON.stringify(this.tags)
  }

  // ---------------------------------------------------------------------------
  // Helpers to ensure whatever is in the input box is captured before the form
  // is submitted (covers the “user never pressed Enter” edge-case)
  // ---------------------------------------------------------------------------

  commitInput() {
    const tag = this.inputTarget.value.trim()
    if (tag !== '') {
      this.addTag(tag)
      this.inputTarget.value = ''
    }
  }

  // Called automatically on <form> submit
  prepareSubmission() {
    this.commitInput()
    this.updateHiddenField()
    // allow form to continue submitting
  }
  
  disconnect() {
    if (this.form && this._submitHandler) {
      this.form.removeEventListener("submit", this._submitHandler)
    }
  }
}
